import { DISK_ADMIN_FILTERS, DISK_ADMIN_SORTS } from '../Contracts/DiskAdmin'

import type { DiskAdminFilter, DiskAdminOrder, DiskAdminSort, DiskPolicyValues } from '../Contracts/DiskAdmin'

/** Стан списку, який живе в адресі: фільтр, пошук, сортування, сторінка. */
export interface DiskAdminStoragesState {
    filter: DiskAdminFilter
    q: string
    sort: DiskAdminSort
    order: DiskAdminOrder
    page: number
}

export const DEFAULT_STORAGES_STATE: DiskAdminStoragesState = {
    filter: 'all',
    q: '',
    sort: 'used',
    order: 'desc',
    page: 1,
}

/** Рядок адреси → стан (невідомі значення — дефолт: бек однаково відповів би 422). */
export const parseStoragesState = (params: URLSearchParams): DiskAdminStoragesState => {
    const filter = params.get('filter')
    const sort = params.get('sort')
    const order = params.get('order')
    const page = Number(params.get('page'))

    return {
        filter: (DISK_ADMIN_FILTERS as readonly string[]).includes(filter ?? '')
            ? (filter as DiskAdminFilter)
            : DEFAULT_STORAGES_STATE.filter,
        q: params.get('q') ?? '',
        sort: (DISK_ADMIN_SORTS as readonly string[]).includes(sort ?? '')
            ? (sort as DiskAdminSort)
            : DEFAULT_STORAGES_STATE.sort,
        order: order === 'asc' || order === 'desc' ? order : DEFAULT_STORAGES_STATE.order,
        page: Number.isInteger(page) && page > 0 ? page : 1,
    }
}

/** Стан → рядок адреси без дефолтних значень. */
export const storagesStateToParams = (state: DiskAdminStoragesState): Record<string, string> => {
    const params: Record<string, string> = {}

    if (state.filter !== DEFAULT_STORAGES_STATE.filter) params['filter'] = state.filter
    if (state.q.trim() !== '') params['q'] = state.q.trim()
    if (state.sort !== DEFAULT_STORAGES_STATE.sort) params['sort'] = state.sort
    if (state.order !== DEFAULT_STORAGES_STATE.order) params['order'] = state.order
    if (state.page > 1) params['page'] = String(state.page)

    return params
}

/** Ключі, що різняться між чернеткою й збереженим, — PATCH шле лише їх. */
export const policyChanges = (saved: DiskPolicyValues, draft: DiskPolicyValues): Partial<DiskPolicyValues> => {
    const changes: Partial<DiskPolicyValues> = {}

    for (const key of Object.keys(draft) as Array<keyof DiskPolicyValues>) {
        if (JSON.stringify(saved[key]) !== JSON.stringify(draft[key])) {
            ;(changes as Record<string, unknown>)[key] = draft[key]
        }
    }

    return changes
}
